import React, { useEffect, useState } from "react";
import { Col, Row, Button } from "react-bootstrap";
import { TextField } from "@material-ui/core";
import Radio from "@material-ui/core/Radio";
import MapSetupOrder from "../../../vendorOnboradingComponents/allScreens/MapSetup/MapSetupOrder";
import { amApi } from "../../../../api/apiHelper";
import { successAlert, errorAlert } from "../../../../function/alert";
import { DELIVERY_TYPES } from "../../../../enums/OrderEnums";

export const SavedAddress = (props) => {
  const [deliverytype, setDeliverytype] = useState("INDEPENDENT");
  const [address, setAddress] = useState({
    address: "",
    area: "",
    city: "",
    state: "",
    pincode: "",
    location: {
      latitude: "",
      longitude: "",
    },
  });

  useEffect(() => {
    if (props?.userData?.address) setAddress(props?.userData?.address);
  }, [props?.userData?.address]);

  const venueLocation = (data) => {
    if (data) {
      props.distCheck(data.location?.latitude, data?.location?.longitude);
      let address1 = data?.address?.split(",").slice(0, -4).join(",");
      setAddress({
        address: address1,
        area: data.area,
        city: data.city,
        state: data.state,
        pincode: data.pinCode,
        location: data.location,
      });
    }
  };

  const saveAddress = async () => {
    if (props?.userData?.mobile_number) {
      let addressObj = {
        type: deliverytype,
        address1: address.address,
        area: address.area,
        city: address.city,
        state: address.state,
        pincode: address.pincode,
        location: address.location,
        isTemp: true,
      };
      let savedAddress = await amApi.post("/address", addressObj);
      if (savedAddress.status === 201) {
        props.tempAddress(savedAddress.data);
        successAlert("Delivery Address Saved for Order");
      } else {
        errorAlert("Error Saving Address for Order Delivery");
      }
    } else {
      errorAlert("Enter Basic Details to Continue");
    }
  };

  return (
    <div>
      {props?.userData?.addressLocations?.map((ele) => (
        <Row
          style={{ backgroundColor: "#ffffff", padding: "15px" }}
          key={ele._id}
        >
          <Col md={1}>
            <Radio
              checked={ele._id === props.selectedAddress._id ? true : false}
              onChange={(e) => {
                props.handleAddress(ele);
              }}
              value={ele}
              name="radio-button-demo"
              color="primary"
              inputProps={{ "aria-label": ele.address1 }}
            />
          </Col>
          <Col md={1}>{/* <img src={ele.icon} /> */}</Col>
          <Col md={8}>
            <div className={"f14-400"}>{`${ele.address1} ${
              ele.address2 ? ", " + ele.address2 : ""
            } ${ele.area ? ", " + ele.area + "," : ""}`}</div>
            <div className={"f14-400"}>{`${ele.locality ? ele.locality : ""} ${
              ele.city ? ", " + ele.city : ""
            } ${ele.state ? ", " + ele.state : ""} ${
              ele.pincode ? ", " + ele.pincode : ""
            }`}</div>
          </Col>
        </Row>
      ))}
      <Row style={{ backgroundColor: "#ffffff", padding: "15px" }}>
        <Col md={1}>
          <Radio
            checked={props.selectedAddress === "NEW" ? true : false}
            onChange={(e) => {
              props.handleAddress("NEW");
            }}
            value={"NEW"}
            name="radio-button-demo"
            color="primary"
            inputProps={{ "aria-label": "New Address" }}
          />
        </Col>
        <Col md={1}>{/* <img src={ele.icon} /> */}</Col>
        <Col md={8}>
          <div className={"f14-400"}>{`Select New Address`}</div>
        </Col>
      </Row>
      {props.selectedAddress === "NEW" && (
        <>
          <Row className="pt-4">
            {DELIVERY_TYPES.map((data) => {
              return (
                <Col md={3} key={data.id} xs={6}>
                  <div
                    className={`rounded-icons 
                                  ${
                                    deliverytype === data.id &&
                                    `rounded-icons-selected`
                                  }`}
                    onClick={(e) => setDeliverytype(data.id)}
                  >
                    <img src={data.icon} alt={data.title} width="80%" />
                  </div>
                  {data.title}
                </Col>
              );
            })}
          </Row>
          <br />
          <MapSetupOrder
            handleLocation={venueLocation}
            defaultCoordinates={props?.userData?.address?.location}
          />
          <Row>
            <Col md={10}>
              <Row>
                <Col xs={12}>
                  <TextField
                    label="Address"
                    variant="outlined"
                    className="w-100"
                    name="address"
                    value={address.address}
                    InputLabelProps={{ shrink: true }}
                    onChange={(e) =>
                      setAddress({ ...address, address: e.target.value })
                    }
                  />
                  <br />
                  <br />
                </Col>
                <Col md={6}>
                  <TextField
                    label="Area"
                    variant="outlined"
                    className="w-100"
                    name="area"
                    value={address.area}
                    onChange={(e) =>
                      setAddress({ ...address, area: e.target.value })
                    }
                  />
                  <br />
                  <br />
                </Col>
                <Col md={6}>
                  <TextField
                    label="City"
                    variant="outlined"
                    className="w-100"
                    name="city"
                    value={address.city}
                    onChange={(e) =>
                      setAddress({ ...address, city: e.target.value })
                    }
                  />
                  <br />
                  <br />
                </Col>
                <Col md={6}>
                  <TextField
                    label="State"
                    variant="outlined"
                    className="w-100"
                    name="State"
                    value={address.state}
                    onChange={(e) =>
                      setAddress({ ...address, state: e.target.value })
                    }
                  />
                  <br />
                  <br />
                </Col>
                <Col md={6}>
                  <TextField
                    label="PIN/ZIP Code"
                    variant="outlined"
                    className="w-100"
                    name="pincode"
                    value={address.pincode}
                    InputLabelProps={{ shrink: address?.pincode ? true : false}}
                    onChange={(e) =>
                      setAddress({ ...address, pincode: e.target.value })
                    }
                  />
                  <br />
                  <br />
                </Col>
                <Col md={6}>
                  <TextField
                    label="Latitude"
                    variant="outlined"
                    className="w-100"
                    name="latitude"
                    value={address.location?.latitude}
                    onChange={(e) =>
                      setAddress({
                        ...address,
                        location: {
                          ...address.location,
                          latitude: e.target.value,
                        },
                      })
                    }
                  />
                  <br />
                  <br />
                </Col>
                <Col md={6}>
                  <TextField
                    label="Longitude"
                    variant="outlined"
                    className="w-100"
                    name="longitude"
                    value={address.location?.longitude}
                    onChange={(e) =>
                      setAddress({
                        ...address,
                        location: {
                          ...address.location,
                          longitude: e.target.value,
                        },
                      })
                    }
                  />
                  <br />
                  <br />
                </Col>
              </Row>
            </Col>
          </Row>
          <Button
            variant="danger"
            className="px-5  py-2"
            type="button"
            onClick={saveAddress}
          >
            Save Address
          </Button>
        </>
      )}
    </div>
  );
};
